import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { FaUser, FaBars, FaTimes } from 'react-icons/fa';
import { logo_black } from '../../imports';
import { useAuth } from '../../context/AuthContext';
import './Navbar.css';

const NavBar = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);
    const navigate = useNavigate();
    const location = useLocation();
    const { currentUser, userName, signOut } = useAuth();

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // Close dropdown on route change
    useEffect(() => {
        setIsDropdownOpen(false);
        setIsMobileMenuOpen(false);
    }, [location.pathname]);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    const handleLogout = async () => {
        try {
            await signOut();
            setIsDropdownOpen(false);
            navigate('/', { replace: true });
        } catch (error) {
            console.error('Logout error:', error);
        }
    };

    const handleDashboardClick = () => {
        setIsDropdownOpen(false);
        const dashboardPath = currentUser?.role === 'admin' ? '/admin' : '/user';
        navigate(dashboardPath, { replace: true });
    };

    return (
        <nav className="navbar-container">
            <Link to='/' className="navbar-logo-container">
                <div className="navbar-logo">
                    <img src={logo_black} alt="logo" />
                </div>
                <div className="navbar-logo-text">
                    <h3>Premium Mobile Car Detailing</h3>
                    <p>Bringing back that new car feeling</p>
                </div>
            </Link>
            <div className={`navbar-menu ${isMobileMenuOpen ? 'navbar-menu--open' : ''}`}>
                <Link to="/services" className="navbar-item">Services</Link>
                <Link to="/giftcards" className="navbar-item">Gift cards</Link>
                <Link to="/contact" className="navbar-item">Contact</Link>
                <div className="navbar-auth" ref={dropdownRef}>
                    <button className="navbar-item navbar-user-button" onClick={toggleDropdown}>
                        <FaUser className="navbar-icon" />
                        {currentUser && <span className="navbar-username">{userName}</span>}
                    </button>
                    {isDropdownOpen && (
                        <div className="navbar-dropdown">
                            {currentUser ? (
                                <>
                                    <div className="navbar-dropdown-header">
                                        Hi, {userName}
                                    </div>
                                    <button onClick={handleDashboardClick} className="navbar-dropdown-item">
                                        Dashboard
                                    </button>
                                    <button onClick={handleLogout} className="navbar-dropdown-item">
                                        Logout
                                    </button>
                                </>
                            ) : (
                                <>
                                    <Link to="/signin" className="navbar-dropdown-item">
                                        Sign In
                                    </Link>
                                    <Link to="/signup" className="navbar-dropdown-item">
                                        Sign Up
                                    </Link>
                                </>
                            )}
                        </div>
                    )}
                </div>
            </div>
            <div className="navbar-hamburger" onClick={toggleMobileMenu}>
                {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
            </div>
        </nav>
    );
};

export default NavBar;